// colors:
// 'light',
// 'dark',
// 'grey',
// 'primary',
// 'standout',
// 'custom',

const getBackgroundColor = (theme, color, customColor) => {
  switch (color) {
    case 'light':
      return theme.pagebuilder?.backgroundLight || 'white';
    case 'dark':
      return theme.pagebuilder?.backgroundDark || theme.grayDarkColor;
    case 'grey':
      return theme.pagebuilder?.backgroundGrey || theme.grayLightColor;
    case 'primary':
      return theme.primaryColor;
    case 'standout':
      return theme.standoutColor;
    case 'custom':
      return customColor;
    default:
      return 'none';
  }
};

export default getBackgroundColor;
